import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'client/reducers/paymentReducer'

export default function usePayment(selector) {
  return useSelector(state => selector(state.payment), shallowEqual)
}

export { selectors }
